import { Controller } from "@hotwired/stimulus";
import TomSelect from "tom-select";

// Connects to data-controller="tom-select-create"
export default class extends Controller {
  static targets = ['items'];
  static values = { collection: String, showRemoveButton: Boolean };

  connect() {
    const selectInput = this.itemsTarget;
    const collection = this.collectionValue;
    const showRemoveButton = this.showRemoveButtonValue;

    // Define base config for TomSelect
    let tomSelectConfig = {
      onItemAdd:function(){
        this.setTextboxValue('');
        this.refreshOptions();
      },
      persist: false,
      create: async (input, callback) => {
        const data = { name: input };
        const token = document.querySelector('meta[name="csrf-token"]').content;

        let response = await fetch(`/${collection}`, {
          method: 'POST',
          headers: {
            "X-CSRF-Token": token,
            "Content-Type": "application/json",
            "Accept": "application/json"
          },
          body: JSON.stringify(data)
        });

        if (!response.ok) {
          // Handle error response, perhaps log it or show a message to the user
          console.error('Server responded with an error:', response.status);
          return;
        }

        let newItem = await response.json();
        callback({ value: newItem.id, text: newItem.name });
      }
    };

    // Conditionally add removeButton plugin configuration
    if (showRemoveButton) {
      tomSelectConfig.plugins = {
        remove_button: {
          title: 'Remove this item',
        }
      };
      tomSelectConfig.onDelete = function(values) {
        return confirm(values.length > 1 ? 'Are you sure you want to remove these ' + values.length + ' items?' : 'Are you sure you want to remove "' + values[0] + '"?');
      };
    }

    // Initialize TomSelect with the configured options
    if (selectInput) {
      new TomSelect(selectInput, tomSelectConfig);
    }
  }
}
